<template>
  <div>
    <!--SENDING ACCOUNT-->
    <v-text-field
      v-model.sync="modelSendingAccount"
      :disabled="!isSettingsEnabled"
      label="Sending Email Account"
      class="mw-400"
      type="text"
      hide-details
    >
    </v-text-field>

    <!--SERVER-->
    <v-text-field
      v-model.sync="modelServer"
      :disabled="!isSettingsEnabled"
      label="Server"
      class="mw-400"
      hide-details
    >
    </v-text-field>

    <!--PORT-->
    <v-text-field
      v-model.sync="modelPort"
      :disabled="!isSettingsEnabled"
      class="mw-400"
      maxLength="5"
      label="Port"
      hide-details
    >
    </v-text-field>

    <!--PASSWORD-->
    <v-text-field
      v-model.sync="modelPassword"
      :disabled="!isSettingsEnabled"
      :type="showPassword ? 'text' : 'password'"
      autocomplete="new-password"
      class="mw-400"
      label="Password"
      hide-details
    >
      <template v-slot:append>
        <v-icon
          @mousedown="showPassword = true"
          @mouseup="showPassword = false"
          class="pointer"
          >mdi-eye{{ showPassword ? '-off' : '' }}</v-icon
        >
      </template>
    </v-text-field>

    <!--ENCRYPT-->
    <v-switch
      v-model.sync="modelEncrypt"
      :disabled="!isSettingsEnabled"
      hide-details
      label="Encrypted"
      class="mb-2"
    ></v-switch>
  </div>
</template>

<script>
export default {
  name: 'SMTP',
  data() {
    return {
      showPassword: false,
    }
  },
  props: {
    isSettingsEnabled: Boolean,
    backupType: Number,
    organization: Object,
  },

  computed: {
    modelServer: {
      get() {
        switch(this.backupType) {
          case 0:
            return this.organization.emailDefinitions.smtpDefinitions.server
          case 1:
            return this.organization.backupEmailDefinitions.smtpDefinitions.server
          case 2:
            return this.organization.secondBackupEmailDefinitions.smtpDefinitions.server
        }
      },
      set(n) {
        switch(this.backupType) {
          case 0:
            return this.organization.emailDefinitions.smtpDefinitions.server = n
          case 1:
            return this.organization.backupEmailDefinitions.smtpDefinitions.server = n
          case 2:
            return this.organization.secondBackupEmailDefinitions.smtpDefinitions.server = n
        }
      },
    },
    modelPort: {
      get() {
        switch(this.backupType) {
          case 0:
            return this.organization.emailDefinitions.smtpDefinitions.port
          case 1:
            return this.organization.backupEmailDefinitions.smtpDefinitions.port
          case 2:
            return this.organization.secondBackupEmailDefinitions.smtpDefinitions.port
        }
      },
      set(n) {
        switch(this.backupType) {
          case 0:
            return this.organization.emailDefinitions.smtpDefinitions.port = n
          case 1:
            return this.organization.backupEmailDefinitions.smtpDefinitions.port = n
          case 2:
            return this.organization.secondBackupEmailDefinitions.smtpDefinitions.port = n
        }
      },
    },
    modelEncrypt: {
      get() {
        switch(this.backupType) {
          case 0:
            return this.organization.emailDefinitions.smtpDefinitions.encrypt
          case 1:
            return this.organization.backupEmailDefinitions.smtpDefinitions.encrypt
          case 2:
            return this.organization.secondBackupEmailDefinitions.smtpDefinitions.encrypt
        }
      },
      set(n) {
        switch(this.backupType) {
          case 0:
            return this.organization.emailDefinitions.smtpDefinitions.encrypt = n
          case 1:
            return this.organization.backupEmailDefinitions.smtpDefinitions.encrypt = n
          case 2:
            return this.organization.secondBackupEmailDefinitions.smtpDefinitions.encrypt = n
        }
      },
    },
    modelSendingAccount: {
      get() {
        switch(this.backupType) {
          case 0:
            return this.organization.emailDefinitions.smtpDefinitions.senderEmail
          case 1:
            return this.organization.backupEmailDefinitions.smtpDefinitions.senderEmail
          case 2:
            return this.organization.secondBackupEmailDefinitions.smtpDefinitions.senderEmail
        }
      },
      set(n) {
        switch(this.backupType) {
          case 0:
            return this.organization.emailDefinitions.smtpDefinitions.senderEmail = n
          case 1:
            return this.organization.backupEmailDefinitions.smtpDefinitions.senderEmail = n
          case 2:
            return this.organization.secondBackupEmailDefinitions.smtpDefinitions.senderEmail = n
        }
      },
    },
    modelPassword: {
      get() {
        switch(this.backupType) {
          case 0:
            return this.organization.emailDefinitions.smtpDefinitions.password
          case 1:
            return this.organization.backupEmailDefinitions.smtpDefinitions.password
          case 2:
            return this.organization.secondBackupEmailDefinitions.smtpDefinitions.password
        }
      },
      set(n) {
        switch(this.backupType) {
          case 0:
            return this.organization.emailDefinitions.smtpDefinitions.password = n
          case 1:
            return this.organization.backupEmailDefinitions.smtpDefinitions.password = n
          case 2:
            return this.organization.secondBackupEmailDefinitions.smtpDefinitions.password = n
        }
      },
    },
  },
}
</script>
